import { PROFILE_OPTION_SELECT } from '../constants/index';

export interface ProfileAction {
    type: 'PROFILE_OPTION_SELECT';
}
export type ProfileActions = ProfileAction;
export type ProfileSelect = (option: string) => void;

export const profileOptionSelect = (option: string, id: string) => {
    return function (dispatch: Function) {
        dispatch({
            type: PROFILE_OPTION_SELECT,
            payload: {
                option,
                id
            }
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/action/profileActions.ts